import { AbsurdIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import {
  type DeviceViewEdgeEntity,
  type DeviceViewNodeEntity,
  isEdgeEntity,
  isNodeEntity,
} from '../deviceViewTypes';

export const getTableNameSn = (
  deviceViewEntity: DeviceViewNodeEntity | DeviceViewEdgeEntity,
): string => {
  if (isNodeEntity(deviceViewEntity)) {
    return deviceViewEntity.sn;
  }
  if (isEdgeEntity(deviceViewEntity)) {
    return `${deviceViewEntity.sourceSn}_${deviceViewEntity.targetSn}`;
  }
  throw new AbsurdIpfError(
    deviceViewEntity,
    'deviceview entity must be either node or edge',
  );
};
